export function LoadingSpinner() {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-h-full tw-w-full">
      <i className="ck ck-loading fa fa-spin fa-4x tw-text-primary"></i>
    </div>
  )
}
